import { useTheme } from '@mui/material';
import React from 'react';

const RouteArrow = () => {
  const theme = useTheme();
  return (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.59591 0.355922C1.24019 0.00874466 0.670385 0.0156652 0.323207 0.37138C-0.0239702 0.727094 -0.0170497 1.2969 0.338665 1.64408L1.59591 0.355922ZM5.06564 5L5.69426 5.64408C5.8678 5.47471 5.96564 5.24248 5.96564 5C5.96564 4.75752 5.8678 4.52529 5.69426 4.35592L5.06564 5ZM0.338665 8.35592C-0.0170497 8.7031 -0.0239702 9.27291 0.323207 9.62862C0.670385 9.98433 1.24019 9.99126 1.59591 9.64408L0.338665 8.35592ZM0.338665 1.64408L4.43702 5.64408L5.69426 4.35592L1.59591 0.355922L0.338665 1.64408ZM4.43702 4.35592L0.338665 8.35592L1.59591 9.64408L5.69426 5.64408L4.43702 4.35592Z"
        fill={theme.palette.widget['icon-02']}
      />
    </svg>
  );
};

export default RouteArrow;
